module.exports = __webpack_public_path__ + "img/gitee.96c19b90.svg";